export default "__VITE_ASSET__uhgtlryx__"